

import React from 'react';
import AniLink from "gatsby-plugin-transition-link/AniLink"

interface FooterLinkProps {
  href: string;
  text: string;
  hidden?: boolean;
  className?: string;
}

const FooterLink = ({ href, text, hidden, className }: FooterLinkProps) => {
  return (
    <AniLink className={`${hidden ? 'hidden ' : ''}${className || ''}`} fade to={href}>
      {text}
    </AniLink>
  );
};

export default FooterLink;